<template>
  <div id="list-level-sheet">
    <CRow class="level-title">
      <span class="label-level">{{
        $t("employee_level.label_employee_level")
      }}</span>
    </CRow>
    <CRow>
      <CCol col="12" v-for="(item, index) in listEmployeeLevel" :key="index">
        <CRow class="type-level ml-md-4 ml-tablet-0">
          <CCol class="d-flex">
            <CInput
              disabled
              type="text"
              v-model="item.name"
              class="name-level-input"
            />
            <span
              @click="editLevel(item.id, item.name)"
              class="mr-2 delete-btn"
            >
              <CIcon name="cilPencil" class="btn-icon" />
            </span>
            <span @click="deleteOldLevel(item.id)" class="delete-btn">
              <CIcon name="cilTrash" class="btn-icon" />
            </span>
          </CCol>
        </CRow>
      </CCol>
      <div class="btn-add-new">
        <label @click="addNewLevel()">{{
          "+ " + $t("employee_level.button.add_employee_level")
        }}</label>
      </div>
    </CRow>
    <template>
      <b-modal ref="modal-level" hide-footer hide-header centered>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(storeLevel)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{
                    id
                      ? $t("employee_level.popup.edit_employee_level")
                      : $t("employee_level.popup.create_employee_level")
                  }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  rules="required|min:3|max:20"
                  v-slot="{ errors }"
                  :name="$t('employee_level.popup.employee_level')"
                >
                  <b-form-input v-model="employeeLevel"></b-form-input>
                  <span class="require">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("employee_level.button.save") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button
                class="mt-3"
                variant="outline-danger"
                @click="hideModalNote"
                >{{ $t("button.label_action_cancel") }}</b-button
              >
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_employee_level"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      oldLevel: null,
      newLevel: null,
      employeeLevel: "",
      id: ""
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      listEmployeeLevel: "employee-level/employeeLevel"
    })
  },
  async created() {
    await this.getLists();
    this.oldLevel = this.listEmployeeLevel.length;
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    async getLists() {
      await this.$store.dispatch("employee-level/listEmployeeLevel");
    },
    addNewLevel() {
      this.id = "";
      this.$refs["modal-level"].show();
    },
    hideModalNote() {
      this.employeeLevel = "";
      this.$refs["modal-level"].hide();
    },
    async deleteOldLevel(id) {
      const confirm = await this.$confirm(
        this.$t("popup.label_popup_text"),
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      );
      if (!confirm) return;
      await this.$store.dispatch("employee-level/deleteEmployeeLevel", id);
      let message = this.$t(
        "employee_level.popup.delete_employee_level_success"
      );
      this.$toast(
        message,
        this.$t("employee_level.popup.delete_employee_level"),
        2000,
        "b-toaster-top-center",
        "success"
      );
      this.getLists();
    },
    async storeLevel() {
      this.setLoading(true);
      const params = {
        data: { name_level: this.employeeLevel },
        id: this.id
      };
      if (this.id == "") {
        await this.$store
          .dispatch("employee-level/createEmployeeLevel", {
            name_level: this.employeeLevel
          })
          .then(() => {
            let message = this.$t(
              "employee_level.popup.create_employee_level_success"
            );
            this.$toast(
              message,
              this.$t("employee_level.popup.create_employee_level"),
              2000,
              "b-toaster-top-center",
              "success"
            );
            this.getLists();
            this.hideModalNote();
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
          });
      } else {
        await this.$store
          .dispatch("employee-level/updateEmployeeLevel", params)
          .then(() => {
            let message = this.$t(
              "employee_level.popup.edit_employee_level_success"
            );
            this.$toast(
              message,
              this.$t("employee_level.popup.edit_employee_level"),
              2000,
              "b-toaster-top-center",
              "success"
            );
            this.getLists();
            this.hideModalNote();
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
          });
      }
    },
    editLevel(id, name) {
      this.employeeLevel = name;
      this.id = id;
      this.$refs["modal-level"].show();
    }
  }
};
</script>

<style scoped>
#list-level-sheet {
  margin: auto;
  width: 55%;
  border: 1px solid #d8dbe0;
  background-color: #fff;
  padding: 0.75rem 1.25rem;
  margin-bottom: 30px;
}
.level-title {
  margin-right: 0;
  margin-left: 0;
}
.label-level {
  margin-bottom: 4%;
  font-size: 22px;
  font-weight: 600;
}
.name-level {
  margin-left: 1rem;
}
.btn-icon {
  color: red;
}
.name-level-input {
  width: 90%;
  margin-right: 5%;
}
.button {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}
.update {
  margin-right: 10px;
}
.btn-add-new label {
  color: #f6ab5f;
  font-size: 1rem;
  cursor: pointer;
  margin-left: 28px;
}
.delete-btn {
  cursor: pointer;
  margin-top: 0.2rem;
}
label {
  font-weight: 600;
}
.require {
  color: red;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #ffffff;
  opacity: 1;
}
@media only screen and (max-width: 739px) and (-webkit-min-device-pixel-ratio: 0) {
  #list-level-sheet {
    width: 100%;
    padding: 0.75rem 0.5rem;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #list-level-sheet {
    width: 98%;
  }
  .ml-tablet-0 {
    margin-left: 0 !important;
  }
}
</style>
